import {
  LuFile,
  LuFileImage,
  LuFileVideo,
  LuFileMusic,
  LuFileText,
  LuFileCode,
} from 'react-icons/lu'
import type { ComponentType } from 'react'

const byExtension: Record<string, ComponentType> = {
  // Images
  jpg: LuFileImage,
  jpeg: LuFileImage,
  png: LuFileImage,
  gif: LuFileImage,
  webp: LuFileImage,
  svg: LuFileImage,
  ico: LuFileImage,
  bmp: LuFileImage,
  // Video
  mp4: LuFileVideo,
  mov: LuFileVideo,
  avi: LuFileVideo,
  mkv: LuFileVideo,
  webm: LuFileVideo,
  // Audio
  mp3: LuFileMusic,
  wav: LuFileMusic,
  ogg: LuFileMusic,
  flac: LuFileMusic,
  aac: LuFileMusic,
  // Text / docs
  txt: LuFileText,
  md: LuFileText,
  pdf: LuFileText,
  doc: LuFileText,
  docx: LuFileText,
  csv: LuFileText,
  rtf: LuFileText,
  // Code
  js: LuFileCode,
  ts: LuFileCode,
  jsx: LuFileCode,
  tsx: LuFileCode,
  json: LuFileCode,
  html: LuFileCode,
  css: LuFileCode,
  yml: LuFileCode,
  yaml: LuFileCode,
  xml: LuFileCode,
  py: LuFileCode,
  go: LuFileCode,
  rs: LuFileCode,
  sh: LuFileCode,
  toml: LuFileCode,
}

export const getFileIcon = (name: string): ComponentType => {
  const ext = name.split('.').pop()?.toLowerCase() ?? ''
  return byExtension[ext] ?? LuFile
}
